/**
 * Generate a unique project ID in the format: proj_XXXXXXXXXXXXXXXXXXXX
 * Similar to ULID format: timestamp + randomness
 */
export function generateProjectId(): string {
  const timestamp = Date.now().toString(36).toUpperCase()
  const randomPart = Math.random().toString(36).substring(2, 15).toUpperCase()
  const randomPart2 = Math.random().toString(36).substring(2, 15).toUpperCase()

  return `proj_${timestamp}${randomPart}${randomPart2}`.substring(0, 32)
}
